export type DirectIntegrationTab = "keys" | "docs";

export function directIntegrationSearch(search: Record<string, unknown>): {
  tab?: DirectIntegrationTab;
} {
  return search.tab === "keys" || search.tab === "docs" ? { tab: search.tab } : {};
}
